import { createFileRoute } from "@tanstack/react-router";
import Index from "@/pages/Index";
import { publicToolHead } from "@/lib/publicToolRoutes";

const Page = () => <Index toolKey="cases" routeLang="es" />;

export const Route = createFileRoute("/casos-reales/")({
  head: () => publicToolHead("cases", "es"),
  component: Page,
  errorComponent: Page,
  notFoundComponent: Page,
});
